<template>
  <div v-loading="loading">
    <el-table :data="tableData" style="width: 100%; margin-top: 20px" border stripe>
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="NAME" label="大类名称"></el-table-column>
      <el-table-column prop="action" label="操作">
        <template slot-scope="scope">
          <!-- <el-button type="text" size="small" @click="checkSupplierPrice(scope.row)" v-show="fun_dic[103010101]">查看报价</el-button> -->
          <el-button type="text" size="small" @click="checkSupplierPrice(scope.row)">查看报价</el-button>
          <!-- <el-button type="text" size="small" @click="shelvesProduct(scope.row)">上架</el-button> -->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      loading: false,
      COMPARE_ID: 0,
      PAGE_ID: '1030101', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 103010101: 0 },
      //   提交状态
      btnStatus: Number(this.$route.params.status),
    };
  },
  created() {
    this.getSupplierPrice();
    this.COMPARE_ID = Number(sessionStorage.getItem('COMPARE_ID'));
    // console.log(this.COMPARE_ID);
    this.queryBeforeFun();
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 获取大类列表
    getSupplierPrice() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 26,
        COMPARE_ID: Number(this.$route.params.compareId),
        SUPPLIER_ID: Number(this.$route.params.supplierId),
      };
      http.post(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '暂无数据', type: 'success' });
        } else {
          this.tableData = res;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 查看供应商比价详情
    checkSupplierPrice(row) {
      this.$router.push({ path: `/suPriceDetail/${this.$route.params.recordId}/${row.F_CAT_ID}/${this.$route.params.status}`, params: { id: this.$route.params.recordId, fCatId: row.F_CAT_ID, status: this.$route.params.status } });
    },
    // 上架
    shelvesProduct(row) {
      this.loading = true;
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 25,
        COMPARE_ID: Number(this.$route.params.compareId),
        RECORD_ID: Number(this.$route.params.recordId),
        TC_ID: Number(sessionStorage.getItem('companyId')),
        SUPPLIER_ID: Number(this.$route.params.supplierId),
        F_CAT_ID: row.F_CAT_ID,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '上架成功', type: 'success' });
        this.loading = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.pagination_box {
  float: right;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/scName.vue